import { type ColumnPickerConfig } from './form/ColumnPickerSchema.tsx';

export const ColumnPickerLocalState = {
  read(id: string | undefined): ColumnPickerConfig {
    if (!id) return { columns: [] };
    return JSON.parse(localStorage.getItem(`pckcol-${id}`) ?? '[]');
  },
  write(id: string, values: ColumnPickerConfig | null) {
    if (!values) {
      localStorage.removeItem(`pckcol-${id}`);
      return;
    }
    localStorage.setItem(`pckcol-${id}`, JSON.stringify(values));
  },
};
